import Util from './Util.js'

const basicField = /^[a-zA-Z][a-zA-Z0-9.\\-_]*$/

export default {
  id : 'Expression.FieldParser.BasicField',
  type : 'basicField',
  sort : 0,
  handles : ( field, context ) => {
    const allowStar = context?.allowStar !== false
    if ( field.type !== 'ExpressionParser.Field' ) {
      return false
    }
    const hasAlias = Util.handleAlias( field.value, { context } )
    if ( hasAlias ) {
      return hasAlias.field?.match( basicField ) || ( hasAlias.field.value === '*' && allowStar )
    }
    return field.value?.match( basicField ) || ( field.value === '*' && allowStar )
  },
  parse : async ( field, context ) => {
    const hasAlias = Util.handleAlias(
      field.value,
      { context : { ...context } }
    )
    const toReturn = {
      type : 'ExpressionField.basic',
      value : field.value
    }
    if ( hasAlias ) {
      toReturn.value = hasAlias.field
      toReturn.alias = hasAlias.alias
    }
    if ( context?.includeAstInfo ) {
      toReturn.untrimmed = field.untrimmed
      toReturn.absoluteLocation = {
        startIndex : field.startIndex,
        endIndex : field.startIndex +
          ( hasAlias ? hasAlias.field.length : field.value.length ),
      }
      toReturn.relativeLocation = {
        startIndex : 0,
        endIndex : hasAlias ? hasAlias.field.length : field.value.length
      }
      if ( hasAlias ) {
        toReturn.aliasLocation = {
          absolute : hasAlias.absoluteLocation,
          relative : hasAlias.relativeLocation,
        }
      }
    }
    return toReturn
  }
}
